import React, { FC, lazy } from "react";
import { Router, Switch, Route, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";
import * as AppRoutesConstants from "./routeConstants/appRoutes";
import isAuthenticated from "../shared/components/HOC/requireAuth";
import { RouterProps } from "../shared/types/route.type";
import { nanoid } from "nanoid";
import LazySuspense from "../shared/components/LazySuspense";

const { AUTH, APP, LOGIN } = AppRoutesConstants;

export const appHistory = createBrowserHistory();

const AuthWrapper = lazy(() => import("../views/Auth/AuthWrapper"));
const AppWrapper = lazy(() => import("../views/App/AppWrapper"));
const TermsAndContionsModal = lazy(
  () => import("../shared/components/TermsAndContionsModal")
);

interface Props {
  redirectUrl?: string;
}
const AppRoutes = ({ redirectUrl }: Props) => {
  const routes: RouterProps[] = [
    { id: "authWrapper", exact: false, path: AUTH, component: AuthWrapper },
    {
      id: "appWrapper",
      exact: false,
      path: APP,
      component: isAuthenticated(AppWrapper),
    },
  ];

  return (
    <div>
      <Router history={appHistory}>
        <LazySuspense>
          <TermsAndContionsModal />
          <Switch>
            {routes.map((route) => (
              <Route
                {...route}
                key={route.id || nanoid()}
                component={route.render ? undefined : (route.component as FC)}
                render={route.render}
              />
            ))}
            <Route path="*" render={() => <Redirect to={LOGIN} />} />
            {redirectUrl ? <Redirect to={redirectUrl} /> : null}
          </Switch>
        </LazySuspense>
      </Router>
    </div>
  );
};

export default AppRoutes;
